// extracted by mini-css-extract-plugin
export var displayNone = "_qx-6";
export var imgContainer = "_qx-2";
export var overflowHidden = "_qx-3";
export var productInfoCardButtonContainer = "_qx-5";
export var productTitleText = "_qx-4";
export var rightArrow = "_qx-1";
export var rightArrowContainer = "_qx-0";